import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'

/**
 * @typedef {import('./js-doc').V2ClientBrokerAssignmentReleaseRequest} V2ClientBrokerAssignmentReleaseRequest
 * @typedef {import('./js-doc').V2ClientBrokerAssignmentReleaseResponse} V2ClientBrokerAssignmentReleaseResponse
 */


class ClientBrokerAssignment {
  constructor () {
    this.baseURL = `client-broker-assignments`
  }
  /**
   * Create a client broker assignment
   * @param {V2ClientBrokerAssignmentReleaseRequest} payload - V2 create client broker assignment request body
   * @returns {Promise<V2ClientBrokerAssignmentReleaseResponse>} - V2 response body
   */
  async create (payload) {
    try {
      const result = (await(await getAxiosClient(this.baseURL)).post(``, {
        ...payload,
      }))
      return result?.data
    }
    catch (error) {
      CError(`Could not create client broker assignment from V2 API`, error)
      throw error
    }
  }

  /**
   * Update the client broker assignment
   * @param {V2ClientBrokerAssignmentReleaseRequest} payload - V2 update client broker assignment request body
   * @returns {Promise<V2ClientBrokerAssignmentReleaseResponse>} - V2 response body
   */
  async release (payload) {
    try {
      const result = (await(await getAxiosClient(this.baseURL)).post(`release`, {
        ...payload,
      }))
      return result?.data
    }
    catch (error) {
      CError(`Could not release client broker assignment from V2 API`, error)
      throw error
    }
  }
}

export default ClientBrokerAssignment
